import apiClient from './client';
import type { Company, CompanyDetail, CompanyCreateInput, CompanyUpdateInput, UTAGECredentialsInput } from '@/types/company';
import type { PaginatedResponse } from '@/types/api';

export interface CompanyListParams {
  page?: number;
  per_page?: number;
  is_active?: boolean;
}

export const companiesApi = {
  // 法人一覧取得
  getCompanies: async (params?: CompanyListParams): Promise<PaginatedResponse<Company>> => {
    const response = await apiClient.get<PaginatedResponse<Company>>('/api/companies', { params });
    return response.data;
  },

  // 法人詳細取得
  getCompany: async (id: number): Promise<CompanyDetail> => {
    const response = await apiClient.get<CompanyDetail>(`/api/companies/${id}`);
    return response.data;
  },

  // 法人作成
  createCompany: async (data: CompanyCreateInput): Promise<CompanyDetail> => {
    const response = await apiClient.post<CompanyDetail>('/api/companies', data);
    return response.data;
  },

  // 法人更新
  updateCompany: async (id: number, data: CompanyUpdateInput): Promise<CompanyDetail> => {
    const response = await apiClient.patch<CompanyDetail>(`/api/companies/${id}`, data);
    return response.data;
  },

  // 法人削除
  deleteCompany: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/companies/${id}`);
  },

  // UTAGE認証情報更新
  updateUTAGECredentials: async (id: number, data: UTAGECredentialsInput): Promise<Company> => {
    const response = await apiClient.patch<Company>(`/api/companies/${id}/utage-credentials`, data);
    return response.data;
  },
};
